export const TRANS = {
  footnote: { en: 'Footnote', fi: 'Alaviite' },
  idOrigin: { en: 'note', fi: 'viite' },
  idDestination: { en: 'footnote', fi: 'alaviite' },
};
